import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=8b8788d2&class=chart-container&style=position%3A%20relative%3B%20height%3A%2040vh%3B%20width%3A%2080vw&"
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports